import React from 'react';
import type { EfectoControl } from '../types/permisos';
import { useCan } from '../hooks/useCan';

interface CanProps {
  permiso: string;
  efecto?: EfectoControl;
  children: React.ReactElement;
}

const Can: React.FC<CanProps> = ({ permiso, efecto = 'ocultar', children }) => {
  const allowed = useCan(permiso);
  if (allowed) return children;
  if (efecto === 'ocultar') return null;
  if (efecto === 'deshabilitar') {
    return React.cloneElement(children, { disabled: true } as { disabled: boolean });
  }
  return React.cloneElement(children, {
    disabled: true,
    InputProps: { readOnly: true },
  } as { disabled: boolean; InputProps: { readOnly: boolean } });
};

export default Can;
